import React from "react";
import Tag from "../Tag";

function Hero() {
  return (
    <div className="py-[72px] pb-14 border-b border-light-gray">
      <p className="text-[11px] tracking-[0.12em] uppercase text-coral font-semibold mb-4">
        Frontend & Design Engineer · Berlin
      </p>
      <div className="flex items-center justify-between mb-6">
        <h1
          className="font-display font-extrabold text-navy leading-none mb-6"
          style={{ fontSize: "clamp(40px, 7vw, 68px)" }}
        >
          Hi, I'm
          <br />
          Helin.
        </h1>
        <img
          src="/helin.jpg"
          alt="Helin Okcu"
          className="w-32 h-32 rounded-full object-cover object-top flex-shrink-0"
        />
      </div>
      <p className="text-base text-text-muted max-w-[520px] leading-[1.7] mb-8">
        Frontend and design engineer with 3.5 years of experience building
        production-grade React and React Native applications. I work at the
        intersection of design and engineering, comfortable in Figma and
        passionate about interfaces that feel as good as they look.
      </p>
      <div className="flex flex-wrap gap-2">
        <Tag label="React" variant="navy" />
        <Tag label="React Native" variant="navy" />
        <Tag label="TypeScript" variant="coral" />
        <Tag label="Figma" variant="sage" />
      </div>
    </div>
  );
}

export default Hero;
